import { useTranslation } from "react-i18next";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { MessageCircle, Send } from "lucide-react";

interface MessagingPlatformSelectorProps {
  value: string;
  onChange: (value: string) => void;
}

export const MessagingPlatformSelector = ({
  value,
  onChange,
}: MessagingPlatformSelectorProps) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-3">
      <Label>{t("contact.platform.label")}</Label>
      <RadioGroup value={value} onValueChange={onChange}>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="none" id="platform-none" />
          <Label htmlFor="platform-none" className="font-normal cursor-pointer">
            {t("contact.platform.none")}
          </Label>
        </div>
        
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="whatsapp" id="platform-whatsapp" />
          <Label htmlFor="platform-whatsapp" className="font-normal cursor-pointer flex items-center gap-2">
            <MessageCircle className="h-4 w-4 text-[#25D366]" />
            {t("contact.platform.whatsappOnly")}
          </Label>
        </div>
        
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="telegram" id="platform-telegram" />
          <Label htmlFor="platform-telegram" className="font-normal cursor-pointer flex items-center gap-2">
            <Send className="h-4 w-4 text-[#0088cc]" />
            {t("contact.platform.telegramOnly")}
          </Label>
        </div>
        
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="both" id="platform-both" />
          <Label htmlFor="platform-both" className="font-normal cursor-pointer">
            {t("contact.platform.both")}
          </Label>
        </div>
      </RadioGroup>
    </div>
  );
};